import { FlowTypes } from '@interfaces/models';
import { TriageState } from '@interfaces/state';
import { createSelector } from '@ngrx/store';
import {
  selectGiftingCO0Toggle,
  selectInheritanceCO0Toggle,
  selectInternalTransferCO0Toggle,
  selectMinorCO0Toggle,
  selectMultiInheritanceToggle,
  selectTriageState,
} from '@store/selectors';

export const selectIsMinorCO0Flow = createSelector(
  selectTriageState,
  selectMinorCO0Toggle,
  (triageState: TriageState, toggle: boolean) => toggle && triageState.flowType === FlowTypes.MINOR,
);

export const selectIsInheritanceCO0Flow = createSelector(
  selectTriageState,
  selectInheritanceCO0Toggle,
  (triageState: TriageState, toggle: boolean) =>
    toggle && triageState.flowType === FlowTypes.INHERITANCE,
);

export const selectIsInternalTransferCO0Flow = createSelector(
  selectTriageState,
  selectInternalTransferCO0Toggle,
  (triageState: TriageState, toggle: boolean) =>
    toggle && triageState.flowType === FlowTypes.INTERNAL_TRANSFER,
);

export const selectIsGiftingCO0Flow = createSelector(
  selectTriageState,
  selectGiftingCO0Toggle,
  (triageState: TriageState, toggle: boolean) =>
    toggle && triageState.flowType === FlowTypes.GIFTING,
);

export const selectIsMultiInheritanceCO0Flow = createSelector(
  selectTriageState,
  selectMultiInheritanceToggle,
  (triageState: TriageState, toggle: boolean) =>
    toggle && triageState.flowType === FlowTypes.MULTI_INHERITANCE,
);

export const selectIsCO0Flow = createSelector(
  selectIsMinorCO0Flow,
  selectIsInheritanceCO0Flow,
  selectIsInternalTransferCO0Flow,
  selectIsGiftingCO0Flow,
  selectIsMultiInheritanceCO0Flow,
  (
    minorToggle: boolean,
    inheritanceToggle: boolean,
    internalTransferToggle: boolean,
    giftingToggle: boolean,
    multiInheritanceFlow: boolean,
  ) =>
    minorToggle ||
    inheritanceToggle ||
    internalTransferToggle ||
    giftingToggle ||
    multiInheritanceFlow,
);
